import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IconPlayerPlayFilled, IconExclamationCircle, IconPlayerPause } from '@tabler/icons-react'

import { toggleMediaPlayerPlaying } from '@/reducers/media/media.redux'
import { fetchMediaForCallId } from '@/reducers/media/media.actions'
import { Button } from '@/components/buttons/Button'

// TODO: The /calls endpoint does not return with video_status, so we can't determine if it's an "only video" call
export const MediaPlayerButton = ({ call }) => {
  const dispatch = useDispatch()
  const { loading, mediaPlayer } = useSelector((state) => state.media)
  const { isPlaying } = mediaPlayer

  if (!call) {
    return null
  }

  const isCurrentlySelectedPlayer = mediaPlayer.callId === call.call_id

  const handlePlayCall = () => {
    if (isCurrentlySelectedPlayer) {
      dispatch(toggleMediaPlayerPlaying())
    } else {
      dispatch(fetchMediaForCallId(call.call_id))
    }
  }

  const determineIcon = () => {
    // Show exclamation circle if no audio
    if (call.audio_status !== 'available') {
      return <IconExclamationCircle data-testid="no-audio-available" />
    }

    // Toggle pause and play for currently selected player
    if (isCurrentlySelectedPlayer && isPlaying) {
      return <IconPlayerPause data-testid="pause" />
    }

    // Show play button by default
    return <IconPlayerPlayFilled data-testid="play" />
  }

  return (
    <Button
      data-testid="audio-player-button"
      disabled={call.audio_status !== 'available'}
      disabledTooltip="No audio available for this call"
      tooltipProps={{ placement: 'top-start' }}
      small
      circular
      brand={isCurrentlySelectedPlayer}
      onClick={handlePlayCall}
      loading={isCurrentlySelectedPlayer && loading.mediaPlayerByCallId === call.call_id}
    >
      {determineIcon()}
    </Button>
  )
}
